import * as React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import AlarmIcon from '@mui/icons-material/Alarm';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {styled} from '@mui/material/styles';
import selfcheck from "../../assets/images/selfcheck.png";
import { selfQuestionnaires } from "../../utils/selfQuestionnaires";
import {useEffect} from "react";

const SelfStart = () => {
  const questionTime = 20;  // 설문 한 문제당 걸리는 예상 시간
  const navigate = useNavigate();
  const {state} = useLocation();
  const {selfQuestionNo} = state;

  
  
  return (
    <Container sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 8, pl: 2, pr: 2, boxSizing: 'border-box' }} >
      <Top title="자가 진단" />

      <Box sx={{ p: 2, pt: 6, mt:5}}>
        <Box sx={{ p: 2 }}>
          <Typography component="div" sx={{ fontSize: 20, color: '#333', textAlign: 'center', fontWeight: 700, }}>
            {selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].title}
          </Typography>
        </Box>

        <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mt: 1 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              color:'#777',
              '& svg': {
                m: 1,
                color:'#777'
              },
            }}
          >
            <TaskAltIcon sx={{fontSize:20,}} />
            <Typography component="span">문항</Typography>
            <Typography component="span" sx={{pl:1, color:'#555',fontWeight:700}}>
              {selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].questions.length}
            </Typography>
            <Typography component="span" sx={{pr:1.5}}>개</Typography>

            <Divider orientation="vertical" variant="middle" flexItem />

            <AlarmIcon sx={{fontSize:20,}} />
            <Typography component="span">시간</Typography>
            <Typography component="span" sx={{pl:1,  color:'#555', fontWeight:700}}>
              {Math.floor(selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].questions.length*questionTime / 60)}
            </Typography>
            <Typography component="span" >분</Typography>
          </Box>
        </Stack>
      </Box>

      <Box >
        <Img alt="selfcheck" src={selfcheck} sx={{ width: '80%' }} />
      </Box>
      
      <Typography component="div" sx={{ fontSize: 12, color: '#777', textAlign: 'center',m:2,}}>
        본 테스트는 진단 목적이 아닌 위험도를 알아보기위한 간단한 설문입니다. 증상이 심할 경우 전문의와 반드시 상의하세요
      </Typography>

      <Box sx={BtnStyle}>
        <Button variant="contained" sx={BottomBtnStyle}
          onClick={() => navigate('/check/CheckStep', {state: {selfQuestionNo: selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].no}})}
        >
          자가진단 시작하기
        </Button>
      </Box>


      <Bottom />
    </Container>
  );
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: 3,
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default SelfStart;